const ChevronIcon = () => {
  return (
    <svg
      className="h-full w-full fill-none stroke-current"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 14 8"
      height="100%"
      width="100%"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="m1 1 5.326 5.7a.909.909 0 0 0 1.348 0L13 1"
      />
    </svg>
  )
}

export default ChevronIcon
